import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  structuredData = null,
  canonical = null
}) => {
  const siteName = 'Vastré By Vijh';
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const defaultDescription = 'Shop premium men\'s fashion online at Vastré By Vijh (VastreByVijh). Custom tailored suits, designer kurtas, ethnic wear, formal shirts, and premium menswear. Perfect fit guaranteed with personalized measurements. Buy online at vastrebyvijh.com';
  const defaultImage = 'https://images.vastrebyvijh.com/vastre-images/monogram/desktop/2025-08-26/monogram_desktop_1756240573600_0.webp';
  const defaultUrl = 'https://vastrebyvijh.com';
  const defaultKeywords = 'vastrebyvijh, VastreByVijh, vastre by vijh, premium men\'s fashion, online men\'s clothing, designer menswear, ethnic wear online, kurta for men, custom tailored suits, vastrebyvijh.com';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords ? `${defaultKeywords}, ${keywords}` : defaultKeywords} />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url || defaultUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url || defaultUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />
      <meta property="twitter:image" content={image || defaultImage} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
